// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%237a1fc4%27 stroke-width=%272.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.enquire_pg_overlay {
  position: fixed;
  inset: 0;
  z-index: 10000; /* header / drawer / video-ku mela */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(24, 10, 52, 0.55);
  backdrop-filter: blur(8px);
  overflow-y: auto;
  overscroll-behavior: contain;
  animation: enquire_pg_overlay_in 0.28s ease both;
}

.enquire_pg_overlay_out {
  animation: enquire_pg_overlay_out 0.26s ease both;
}

/* ---------- Dialog ---------- */
.enquire_pg_dialog {
  position: relative;
  width: 100%;
  max-width: 372px;
  max-height: calc(100vh - 32px);
  max-height: calc(100dvh - 32px);
  margin: auto;
  padding: 26px 26px 24px;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #fbf9ff 100%);
  box-shadow: 0 30px 80px rgba(24, 10, 52, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.7) inset;
  font-family: "Manrope", "Sora", sans-serif;
  color: #0f0a2a;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  animation: enquire_pg_dialog_in 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.enquire_pg_overlay_out .enquire_pg_dialog {
  animation: enquire_pg_dialog_out 0.26s ease both;
}

.enquire_pg_dialog *,
.enquire_pg_dialog *::before,
.enquire_pg_dialog *::after {
  box-sizing: border-box;
}

/* ---------- Close ---------- */
.enquire_pg_close {
  position: absolute;
  top: 14px;
  right: 14px;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #ece4fb;
  color: #2a1170;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.3s ease, background-color 0.25s ease, color 0.25s ease;
}

.enquire_pg_close:hover {
  background: #40159f;
  color: #ffffff;
  transform: rotate(90deg);
}

.enquire_pg_close:focus-visible {
  outline: 3px solid rgba(122, 31, 196, 0.45);
  outline-offset: 2px;
}

/* ---------- Head ---------- */
.enquire_pg_head {
  padding-right: 44px; /* space for the close button */
  margin-bottom: 16px;
  opacity: 0;
  animation: enquire_pg_fade 0.5s ease 0.1s forwards;
}

.enquire_pg_pill {
  display: inline-block;
  margin-bottom: 10px;
  padding: 5px 11px;
  border-radius: 999px;
  background: #ece4fb;
  font-size: 11.5px;
  font-weight: 700;
  line-height: 1.2;
  color: #4a1a9e;
}

.enquire_pg_title {
  margin: 0 0 8px;
  font-size: 21px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #0f0a2a;
}

.enquire_pg_subtitle {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.55;
  color: #5d5978;
}

/* ---------- Form ---------- */
.enquire_pg_form {
  display: flex;
  flex-direction: column;
  gap: 14px;
  opacity: 0;
  animation: enquire_pg_fade 0.5s ease 0.2s forwards;
}

.enquire_pg_field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.enquire_pg_row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.enquire_pg_label {
  margin-bottom: 6px;
  font-size: 12.5px;
  font-weight: 700;
  line-height: 1.3;
  color: #0f0a2a;
}

.enquire_pg_req {
  margin-left: 1px;
}

.enquire_pg_input {
  display: block;
  width: 100%;
  min-width: 0;
  height: 30px;
  margin: 0;
  padding: 0 12px;
  border: 1px solid #ddd5f0;
  border-radius: 8px;
  background-color: #ffffff;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 500;
  color: #0f0a2a;
  outline: none;
  appearance: none;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.enquire_pg_input::placeholder {
  color: #9a97ab;
  opacity: 1;
}

.enquire_pg_input:hover {
  border-color: #b9a6e6;
}

.enquire_pg_input:focus {
  border-color: #7a1fc4;
  box-shadow: 0 0 0 3px rgba(122, 31, 196, 0.16);
}

.enquire_pg_input:-webkit-autofill,
.enquire_pg_input:-webkit-autofill:focus {
  -webkit-text-fill-color: #0f0a2a;
  -webkit-box-shadow: 0 0 0 40px #ffffff inset;
  -webkit-transition: background-color 9999s ease 0s;
  transition: background-color 9999s ease 0s;
}

.enquire_pg_select {
  padding-right: 34px;
  cursor: pointer;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 13px 13px;
}

.enquire_pg_select::-ms-expand {
  display: none;
}

.enquire_pg_error {
  margin: 5px 0 0;
  font-size: 11.5px;
  line-height: 1.4;
  font-weight: 500;
  color: #d6293e;
}

.enquire_pg_consent {
  margin: 0;
  font-size: 11px;
  line-height: 1.5;
  color: #6a6a7c;
}

/* ---------- Submit ---------- */
.enquire_pg_submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 44px;
  margin: 0;
  padding: 11px 16px;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);
  box-shadow: 0 10px 22px rgba(64, 21, 159, 0.3);
  font-family: inherit;
  font-size: 14.5px;
  font-weight: 700;
  line-height: 1.2;
  color: #ffffff;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: transform 0.25s ease, box-shadow 0.25s ease, opacity 0.25s ease;
}

.enquire_pg_submit:focus-visible,
.enquire_pg_again:focus-visible {
  outline: 3px solid rgba(122, 31, 196, 0.4);
  outline-offset: 2px;
}

.enquire_pg_submit:active:not(:disabled) {
  transform: scale(0.98);
}

.enquire_pg_submit:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

@media (hover: hover) {
  .enquire_pg_submit:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(64, 21, 159, 0.4);
  }
}

/* ---------- Success ---------- */
.enquire_pg_success {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 2px;
  text-align: center;
}

.enquire_pg_success_icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #40159f 0%, #7a1fc4 100%);
  box-shadow: 0 10px 22px rgba(64, 21, 159, 0.28);
  font-size: 29px;
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  animation: enquire_pg_pop 0.6s ease both;
}

.enquire_pg_success_title {
  margin: 0 0 8px;
  font-size: 21px;
  font-weight: 800;
  line-height: 1.25;
  color: #0f0a2a;
}

.enquire_pg_success_text {
  margin: 0 0 20px;
  max-width: 300px;
  font-size: 13.5px;
  line-height: 1.6;
  color: #5d5978;
}

.enquire_pg_again {
  margin-top: 10px;
  padding: 8px 12px;
  border: 0;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  color: #4a1a9e;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.enquire_pg_again:hover {
  text-decoration: underline;
}

/* ---------- Small phones ---------- */
@media (max-width: 480px) {
  .enquire_pg_overlay {
    padding: 10px;
  }

  .enquire_pg_dialog {
    max-height: calc(100dvh - 20px);
    padding: 22px 18px 20px;
    border-radius: 16px;
  }

  /* 16px stops iOS from zooming into the field */
  .enquire_pg_input {
    height: 44px;
    font-size: 16px;
  }
}

@media (max-width: 340px) {
  .enquire_pg_row {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-height: 480px) and (orientation: landscape) {
  .enquire_pg_overlay {
    align-items: flex-start;
    padding: 8px;
  }

  .enquire_pg_dialog {
    max-height: calc(100dvh - 16px);
  }
}

/* ---------- Keyframes ---------- */
@keyframes enquire_pg_overlay_in {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes enquire_pg_overlay_out {
  from { opacity: 1; }
  to   { opacity: 0; }
}

@keyframes enquire_pg_dialog_in {
  from { opacity: 0; transform: translateY(34px) scale(0.95); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes enquire_pg_dialog_out {
  from { opacity: 1; transform: translateY(0) scale(1); }
  to   { opacity: 0; transform: translateY(22px) scale(0.96); }
}

@keyframes enquire_pg_fade {
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
}

@keyframes enquire_pg_pop {
  0%   { opacity: 0; transform: scale(0.4); }
  70%  { opacity: 1; transform: scale(1.12); }
  100% { opacity: 1; transform: scale(1); }
}

/* ---------- Reduced motion ---------- */
@media (prefers-reduced-motion: reduce) {
  .enquire_pg_overlay,
  .enquire_pg_dialog,
  .enquire_pg_head,
  .enquire_pg_form,
  .enquire_pg_success_icon {
    animation: none !important;
    opacity: 1 !important;
  }

  .enquire_pg_close,
  .enquire_pg_input,
  .enquire_pg_submit {
    transition: none !important;
  }
}


/* ---- enquiry extras ---- */
.enquire_pg_pill b { font-weight: 800; }
.enquire_pg_textarea {
  height: auto;
  min-height: 72px;
  padding: 10px 12px;
  resize: vertical;
  line-height: 1.45;
  font-family: inherit;
}
.enquire_pg_dialog { max-height: calc(100vh - 24px); overflow-y: auto; }`, "",{"version":3,"sources":["webpack://./src/POPUP/EnquirePage/EnquirePage.css"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,QAAQ;EACR,cAAc,EAAE,oCAAoC;EACpD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAElC,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,uFAAuF;EACvF,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,8EAA8E;AAChF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB,EAAE,+BAA+B;EACpD,mBAAmB;EACnB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EAEb,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,gCAAgC;EAChC,4CAA4C;EAC5C,kDAA0C;EAA1C,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yDAA0Q;EAC1Q,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,8CAA8C;EAC9C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,2EAA2E;AAC7E;;AAEA;;EAEE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;IAC3B,8CAA8C;EAChD;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,+CAA+C;EAC/C;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA,oCAAoC;AACpC;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,uCAAuC,EAAE;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA,yCAAyC;AACzC;EACE;;;;;IAKE,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;;;IAGE,2BAA2B;EAC7B;AACF;;;AAGA,6BAA6B;AAC7B,qBAAqB,gBAAgB,EAAE;AACvC;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA,qBAAqB,8BAA8B,EAAE,gBAAgB,EAAE","sourcesContent":["\n.enquire_pg_overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000; /* header / drawer / video-ku mela */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(24, 10, 52, 0.55);\n  -webkit-backdrop-filter: blur(8px);\n  backdrop-filter: blur(8px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  animation: enquire_pg_overlay_in 0.28s ease both;\n}\n\n.enquire_pg_overlay_out {\n  animation: enquire_pg_overlay_out 0.26s ease both;\n}\n\n/* ---------- Dialog ---------- */\n.enquire_pg_dialog {\n  position: relative;\n  width: 100%;\n  max-width: 372px;\n  max-height: calc(100vh - 32px);\n  max-height: calc(100dvh - 32px);\n  margin: auto;\n  padding: 26px 26px 24px;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #ffffff 0%, #fbf9ff 100%);\n  box-shadow: 0 30px 80px rgba(24, 10, 52, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.7) inset;\n  font-family: \"Manrope\", \"Sora\", sans-serif;\n  color: #0f0a2a;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  box-sizing: border-box;\n  animation: enquire_pg_dialog_in 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.enquire_pg_overlay_out .enquire_pg_dialog {\n  animation: enquire_pg_dialog_out 0.26s ease both;\n}\n\n.enquire_pg_dialog *,\n.enquire_pg_dialog *::before,\n.enquire_pg_dialog *::after {\n  box-sizing: border-box;\n}\n\n/* ---------- Close ---------- */\n.enquire_pg_close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: #ece4fb;\n  color: #2a1170;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: transform 0.3s ease, background-color 0.25s ease, color 0.25s ease;\n}\n\n.enquire_pg_close:hover {\n  background: #40159f;\n  color: #ffffff;\n  transform: rotate(90deg);\n}\n\n.enquire_pg_close:focus-visible {\n  outline: 3px solid rgba(122, 31, 196, 0.45);\n  outline-offset: 2px;\n}\n\n/* ---------- Head ---------- */\n.enquire_pg_head {\n  padding-right: 44px; /* space for the close button */\n  margin-bottom: 16px;\n  opacity: 0;\n  animation: enquire_pg_fade 0.5s ease 0.1s forwards;\n}\n\n.enquire_pg_pill {\n  display: inline-block;\n  margin-bottom: 10px;\n  padding: 5px 11px;\n  border-radius: 999px;\n  background: #ece4fb;\n  font-size: 11.5px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #4a1a9e;\n}\n\n.enquire_pg_title {\n  margin: 0 0 8px;\n  font-size: 21px;\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -0.01em;\n  color: #0f0a2a;\n}\n\n.enquire_pg_subtitle {\n  margin: 0;\n  font-size: 13.5px;\n  line-height: 1.55;\n  color: #5d5978;\n}\n\n/* ---------- Form ---------- */\n.enquire_pg_form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  opacity: 0;\n  animation: enquire_pg_fade 0.5s ease 0.2s forwards;\n}\n\n.enquire_pg_field {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.enquire_pg_row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.enquire_pg_label {\n  margin-bottom: 6px;\n  font-size: 12.5px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #0f0a2a;\n}\n\n.enquire_pg_req {\n  margin-left: 1px;\n}\n\n.enquire_pg_input {\n  display: block;\n  width: 100%;\n  min-width: 0;\n  height: 30px;\n  margin: 0;\n  padding: 0 12px;\n  border: 1px solid #ddd5f0;\n  border-radius: 8px;\n  background-color: #ffffff;\n  font-family: inherit;\n  font-size: 14px;\n  line-height: 1.3;\n  font-weight: 500;\n  color: #0f0a2a;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n}\n\n.enquire_pg_input::placeholder {\n  color: #9a97ab;\n  opacity: 1;\n}\n\n.enquire_pg_input:hover {\n  border-color: #b9a6e6;\n}\n\n.enquire_pg_input:focus {\n  border-color: #7a1fc4;\n  box-shadow: 0 0 0 3px rgba(122, 31, 196, 0.16);\n}\n\n.enquire_pg_input:-webkit-autofill,\n.enquire_pg_input:-webkit-autofill:focus {\n  -webkit-text-fill-color: #0f0a2a;\n  -webkit-box-shadow: 0 0 0 40px #ffffff inset;\n  transition: background-color 9999s ease 0s;\n}\n\n.enquire_pg_select {\n  padding-right: 34px;\n  cursor: pointer;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%237a1fc4' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 13px 13px;\n}\n\n.enquire_pg_select::-ms-expand {\n  display: none;\n}\n\n.enquire_pg_error {\n  margin: 5px 0 0;\n  font-size: 11.5px;\n  line-height: 1.4;\n  font-weight: 500;\n  color: #d6293e;\n}\n\n.enquire_pg_consent {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.5;\n  color: #6a6a7c;\n}\n\n/* ---------- Submit ---------- */\n.enquire_pg_submit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-height: 44px;\n  margin: 0;\n  padding: 11px 16px;\n  border: 0;\n  border-radius: 8px;\n  background: linear-gradient(100deg, #40159f 0%, #7a1fc4 100%);\n  box-shadow: 0 10px 22px rgba(64, 21, 159, 0.3);\n  font-family: inherit;\n  font-size: 14.5px;\n  font-weight: 700;\n  line-height: 1.2;\n  color: #ffffff;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, opacity 0.25s ease;\n}\n\n.enquire_pg_submit:focus-visible,\n.enquire_pg_again:focus-visible {\n  outline: 3px solid rgba(122, 31, 196, 0.4);\n  outline-offset: 2px;\n}\n\n.enquire_pg_submit:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.enquire_pg_submit:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n@media (hover: hover) {\n  .enquire_pg_submit:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 14px 28px rgba(64, 21, 159, 0.4);\n  }\n}\n\n/* ---------- Success ---------- */\n.enquire_pg_success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 0 2px;\n  text-align: center;\n}\n\n.enquire_pg_success_icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 62px;\n  height: 62px;\n  margin-bottom: 16px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #40159f 0%, #7a1fc4 100%);\n  box-shadow: 0 10px 22px rgba(64, 21, 159, 0.28);\n  font-size: 29px;\n  font-weight: 700;\n  line-height: 1;\n  color: #ffffff;\n  animation: enquire_pg_pop 0.6s ease both;\n}\n\n.enquire_pg_success_title {\n  margin: 0 0 8px;\n  font-size: 21px;\n  font-weight: 800;\n  line-height: 1.25;\n  color: #0f0a2a;\n}\n\n.enquire_pg_success_text {\n  margin: 0 0 20px;\n  max-width: 300px;\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: #5d5978;\n}\n\n.enquire_pg_again {\n  margin-top: 10px;\n  padding: 8px 12px;\n  border: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  color: #4a1a9e;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.enquire_pg_again:hover {\n  text-decoration: underline;\n}\n\n/* ---------- Small phones ---------- */\n@media (max-width: 480px) {\n  .enquire_pg_overlay {\n    padding: 10px;\n  }\n\n  .enquire_pg_dialog {\n    max-height: calc(100dvh - 20px);\n    padding: 22px 18px 20px;\n    border-radius: 16px;\n  }\n\n  /* 16px stops iOS from zooming into the field */\n  .enquire_pg_input {\n    height: 44px;\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 340px) {\n  .enquire_pg_row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-height: 480px) and (orientation: landscape) {\n  .enquire_pg_overlay {\n    align-items: flex-start;\n    padding: 8px;\n  }\n\n  .enquire_pg_dialog {\n    max-height: calc(100dvh - 16px);\n  }\n}\n\n/* ---------- Keyframes ---------- */\n@keyframes enquire_pg_overlay_in {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes enquire_pg_overlay_out {\n  from { opacity: 1; }\n  to   { opacity: 0; }\n}\n\n@keyframes enquire_pg_dialog_in {\n  from { opacity: 0; transform: translateY(34px) scale(0.95); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes enquire_pg_dialog_out {\n  from { opacity: 1; transform: translateY(0) scale(1); }\n  to   { opacity: 0; transform: translateY(22px) scale(0.96); }\n}\n\n@keyframes enquire_pg_fade {\n  from { opacity: 0; transform: translateY(14px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes enquire_pg_pop {\n  0%   { opacity: 0; transform: scale(0.4); }\n  70%  { opacity: 1; transform: scale(1.12); }\n  100% { opacity: 1; transform: scale(1); }\n}\n\n/* ---------- Reduced motion ---------- */\n@media (prefers-reduced-motion: reduce) {\n  .enquire_pg_overlay,\n  .enquire_pg_dialog,\n  .enquire_pg_head,\n  .enquire_pg_form,\n  .enquire_pg_success_icon {\n    animation: none !important;\n    opacity: 1 !important;\n  }\n\n  .enquire_pg_close,\n  .enquire_pg_input,\n  .enquire_pg_submit {\n    transition: none !important;\n  }\n}\n\n\n/* ---- enquiry extras ---- */\n.enquire_pg_pill b { font-weight: 800; }\n.enquire_pg_textarea {\n  height: auto;\n  min-height: 72px;\n  padding: 10px 12px;\n  resize: vertical;\n  line-height: 1.45;\n  font-family: inherit;\n}\n.enquire_pg_dialog { max-height: calc(100vh - 24px); overflow-y: auto; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
